<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getPostList_data.postName"
          placeholder="请输入岗位名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getPostList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <!-- <el-col :span="6" >
        <el-button
          @click=" $form('addPost') "

          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加岗位
        </el-button>
      </el-col> -->
    </el-row>

    <mytable
      :tableColums='tableColums_getPostList'
      api='getPostList'
      updateapi='updatePost'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addPost:    [ "新增岗位信息", "el-icon-circle-plus" ],
        updatePost: [ "修改岗位信息", "el-icon-edit-outline"],
        $succeed$: getPostList
      }'
      @close='$form("addPost","reset")' >
  	  <template v-slot:postId="{Myformdata}" >
  		  <el-select v-model='Myformdata.postId' >
  			   <el-option >444444444</el-option>
  		  </el-select>
  	  </template>
      <!-- <hide slot='id' /> -->
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      postId: null,

      tableColums_getPostList: {
        $selection: false,

        postName: '岗位名称',

        postRemark: '岗位描述',

        // $operation: [
        //   '操作', 200,
        //   `@text: 编辑#success
        //    @click: $form("updatePost",$row)
        //   `,
        //   `@text: 删除#danger
        //    @v-if: $row.id != 33 && $row.id != 35
        //    @click: _confirm('确定要删除该岗位吗?')
        //            .trigger('deletePost',{postId:$row.postId})
        //            .trigger('getPostList')
        //   `,
        // ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getPostList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/User/PostManage.vue